import {
  withTranslation,
} from 'react-i18next';

import RegattaResultTableFieldsView from './RegattaResultTableFieldsView';

const TranslatedComponent = withTranslation()(RegattaResultTableFieldsView);

const Component = TranslatedComponent;

export default Component;
